/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_S3_DInputs */

const en_mk_abt_s3_d = /** @type {(inputs: Mk_Abt_S3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neither exists yet and we promise no date. If one of them is a hard requirement for your organisation, the Security & data page states the position plainly. Self-hosting, on the other hand, is available to discuss — not as a download, but as an installation we do with you.`)
};

const id_mk_abt_s3_d = /** @type {(inputs: Mk_Abt_S3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keduanya belum ada dan kami tidak menjanjikan tanggal. Kalau salah satunya syarat mutlak bagi organisasi Anda, halaman Keamanan & data menjelaskan keadaannya apa adanya. Self-host sendiri sudah bisa dibicarakan — bukan sebagai paket unduhan, melainkan pemasangan yang kami kerjakan bersama Anda.`)
};

/**
* | output |
* | --- |
* | "Neither exists yet and we promise no date. If one of them is a hard requirement for your organisation, the Security & data page states the position plainly. ..." |
*
* @param {Mk_Abt_S3_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_s3_d = /** @type {((inputs?: Mk_Abt_S3_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_S3_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_s3_d(inputs)
	return en_mk_abt_s3_d(inputs)
});